import React from 'react'

import Image from '../../Image';

export default function StepTwo({ hideQaAndDataAnalytics = false }) {
   return (
      <div className='st_eac'>
         <div className='steps_t_2'>Choose your Job Track</div>
         <div className='st_inf_txt'>
         Find the Job Track that best aligns with your career goals.
         </div>
         <div className='st_ops'>
            <div className='st_op_c'>
               <div
                  className='st_o_ntx'
                  style={{ backgroundColor: '#dbeafe', color: '#1e40af' }}
               >
                  Online
               </div>
               <div className='st_op_h_tx'>MERN Full Stack</div>
               <div className='st_t_im_c'>
                  <Image
                     src='https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/nxtwave-intensive-2.0/clock.svg'
                     alt='clock'
                     height={18}
                     width={18}
                     loading='lazy'
                  />
                  <div className='dur_txt'>
                     Duration: <span className='st_d_m'>8 Months (Includes Fundamentals)</span>
                  </div>
               </div>
               <div className='st_t_im_c'>
                  <Image
                     src='https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/nxtwave-intensive-2.0/salary-note.svg'
                     alt='salary-note'
                     height={18}
                     width={18}
                     loading='lazy'
                  />
                  <div className='st_sl_t'>
                     Mode :
                  </div>
                  <div className='st_sl_n'>Online</div>
               </div>
               <div className='st_t_im_c'>
                  <Image
                     src='https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/nxtwave-intensive-2.0/rocket.svg'
                     alt='rocket'
                     height={18}
                     width={18}
                     loading='lazy'
                  />
                  <div className='st_inf_txt'>10+ Real-time projects</div>
               </div>
               <div className='st_ln_co'>
                  <Image
                     src='https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/nxtwave-intensive-2.0/mongo-db-logo.png'
                     className='st_e_lim'
                     alt='mongo-db-logo'
                     height={80}
                     width={100}
                     loading='lazy'
                  />
                  <Image
                     src='https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/intensive/express-js.png'
                     className='st_e_lim'
                     alt='express-js'
                     height={100}
                     width={104}
                     loading='lazy'
                  />
                  <Image
                     src='https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/intensive/react-js.png'
                     className='st_e_lim'
                     alt='react-js'
                     height={100}
                     width={100}
                     loading='lazy'
                  />
                  <Image
                     src='https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/intensive/node-js.png'
                     className='st_e_lim'
                     alt='node-js'
                     height={100}
                     width={100}
                     loading='lazy'
                  />
               </div>
            </div>
            <div className='st_op_c'>
               <div
                  className='st_o_ntx'
                  style={{ backgroundColor: '#ffedd5', color: '#9a3412' }}
               >
                  Online
               </div>
               <div className='st_op_h_tx'>Java Full Stack</div>
               <div className='st_t_im_c'>
                  <Image
                     src='https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/nxtwave-intensive-2.0/clock.svg'
                     alt='clock'
                     height={18}
                     width={18}
                     loading='lazy'
                  />
                  <div className='dur_txt'>
                     Duration: <span className='st_d_m'>8 Months (Includes Fundamentals)</span>
                  </div>
               </div>
               <div className='st_t_im_c'>
                  <Image
                     src='https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/nxtwave-intensive-2.0/salary-note.svg'
                     alt='salary-note'
                     height={18}
                     width={18}
                     loading='lazy'
                  />
                  <div className='st_sl_t'>
                  Mode :
                  </div>
                  <div className='st_sl_n'>Online</div>
               </div>
               <div className='st_t_im_c'>
                  <Image
                     src='https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/nxtwave-intensive-2.0/rocket.svg'
                     alt='rocket'
                     height={18}
                     width={18}
                     loading='lazy'
                  />
                  <div className='st_inf_txt'>10+ Real-time projects</div>
               </div>
               <div className='st_ln_co'>
                  <Image
                     src='https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/intensive/react-js.png'
                     className='st_e_lim'
                     alt='react-js'
                     height={100}
                     width={100}
                     loading='lazy'
                  />
                  <Image
                     src='https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/intensive/java.png'
                     className='st_e_lim'
                     alt='java'
                     height={80}
                     width={100}
                     loading='lazy'
                  />
                  <Image
                     src='https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/intensive/spring-boot.png'
                     className='spring'
                     alt='spring-boot'
                     height={100}
                     width={104}
                     loading='lazy'
                  />
               </div>
            </div>
            {!hideQaAndDataAnalytics && (
            <>
            <div className='st_op_c'>
               <div
                  className='st_o_ntx'
                  style={{ backgroundColor: '#dbeafe', color: '#6b21a8' }}
               >
                  Training Center
               </div>
               <div className='st_op_h_tx'>Python Full Stack with GenAI</div>
               <div className='st_t_im_c'>
                  <Image
                     src='https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/nxtwave-intensive-2.0/clock.svg'
                     alt='clock'
                     height={18}
                     width={18}
                     loading='lazy'
                  />
                  <div className='dur_txt'>
                     Duration: <span className='st_d_m'>6 Months (Includes Fundamentals)</span>
                  </div>
               </div>
               <div className='st_t_im_c'>
                  <Image
                     src='https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/nxtwave-intensive-2.0/salary-note.svg'
                     alt='salary-note'
                     height={18}
                     width={18}
                     loading='lazy'
                  />
                  <div className='st_sl_t'>
                     Mode : 
                  </div>
                  <div className='st_sl_n'>In-Person</div>
               </div>
               <div className='st_t_im_c'>
                  <Image
                     src='https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/nxtwave-intensive-2.0/rocket.svg'
                     alt='rocket'
                     height={18}
                     width={18}
                     loading='lazy'
                  />
                  <div className='st_inf_txt'>10+ Real-time projects</div>
               </div>
               <div className='st_ln_co'>
                  <Image
                     src='https://cdn.prod.website-files.com/5fa61cbbf0d432b3230f62b1/6916dacc41eae1c12e25cd80_python-logo.avif'
                     className='st_e_lim'
                     alt='mongo-db-logo'
                     height={80}
                     width={100}
                     loading='lazy'
                  />
                  <Image
                     src='https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/intensive/express-js.png'
                     className='st_e_lim'
                     alt='express-js'
                     height={100}
                     width={104}
                     loading='lazy'
                  />
                  <Image
                     src='https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/intensive/react-js.png'
                     className='st_e_lim'
                     alt='react-js'
                     height={100}
                     width={100}
                     loading='lazy'
                  />
                  <Image
                     src='https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/intensive/node-js.png'
                     className='st_e_lim'
                     alt='node-js'
                     height={100}
                     width={100}
                     loading='lazy'
                  />
               </div>
            </div>
            <div className='st_op_c'>
               <div
                  className='st_o_ntx'
                  style={{ backgroundColor: '#d1fae5', color: '#065f46' }}
               >
                  Training Center
               </div>
               <div className='st_op_h_tx'>Java Full Stack with Gen AI</div>
               <div className='st_t_im_c'>
                  <Image
                     src='https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/nxtwave-intensive-2.0/clock.svg'
                     alt='clock'
                     height={18}
                     width={18}
                     loading='lazy'
                  />
                  <div className='dur_txt'>
                     Duration: <span className='st_d_m'>6 Months (Includes Fundamentals)</span>
                  </div>
               </div>
               <div className='st_t_im_c'>
                  <Image
                     src='https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/nxtwave-intensive-2.0/salary-note.svg'
                     alt='salary-note'
                     height={18}
                     width={18}
                     loading='lazy'
                  />
                  <div className='st_sl_t'>
                     Mode :
                  </div>
                  <div className='st_sl_n'>In-Person</div>
               </div>
               <div className='st_t_im_c'>
                  <Image
                     src='https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/nxtwave-intensive-2.0/rocket.svg'
                     alt='rocket'
                     height={18}
                     width={18}
                     loading='lazy'
                  />
                  <div className='st_inf_txt'>10+ Real-time projects</div>
               </div>
               <div className='st_ln_co'>
                  <Image
                     src='https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/intensive/react-js.png'
                     className='st_e_lim'
                     alt='react-js'
                     height={100}
                     width={100}
                     loading='lazy'
                  />
                  <Image
                     src='https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/intensive/java.png'
                     className='st_e_lim'
                     alt='java'
                     height={80}
                     width={100}
                     loading='lazy'
                  />
                  <Image
                     src='https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/intensive/spring-boot.png'
                     className='spring'
                     alt='spring-boot'
                     height={100}
                     width={104}
                     loading='lazy'
                  />
               </div>
            </div>
            </>
            )}
         </div>
      </div>
   )
}
